import { Button, Card } from "antd";

import LocationPicker from "@/components/LocationPicker";
import { LocationsMap } from "@/components/LocationsMap";
import { LocationsMapProps } from "@/components/LocationsMap/LocationsMap";
import { HeatMapOutlined } from "@ant-design/icons";

interface LocationsCardProps {
  selectedId: string | undefined;
  defaultAreaCoverageInMeters: number | undefined;
  loading: boolean;
  locations: LocationsMapProps["locations"];
  onClick: (locationId: string) => void;
  onMapClick: () => void;
}

export function LocationsCard({ selectedId, defaultAreaCoverageInMeters, loading, locations, onClick, onMapClick }: LocationsCardProps) {
  const locations_ = locations.filter(x => x.deletedAt === null);

  return (
    <Card
      actions={[
        <Button key="map" icon={<HeatMapOutlined />} variant="link" onClick={onMapClick}>
          Op kaart bekijken
        </Button>
      ]}
      loading={loading}
      title={`Locaties (${locations_.length})`}
      extra={
        <LocationPicker
          autoSelectDefault
          onChange={onClick}
          style={{ width: 300 }}
          value={selectedId}
        />
      }
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <LocationsMap
        defaultAreaCoverageInMeters={defaultAreaCoverageInMeters}
        locations={locations_}
        selectedLocationId={selectedId}
        onLocationSelect={onClick}
      />
    </Card>
  );
}
